import { ClientCommerceId, ClientProfile } from '@shared/models';

export interface CreateClientPayload {
  firstname: string;
  lastname: string;
  email: string;
  profile: ClientProfile;
  commerce_id: ClientCommerceId;
  id_number: number;
  phone_number: number;
  address: string;
}
